export const RESET_CREATE_SEND = 'RESET_CREATE_SEND';

export const resetCreateSend = () => ({
  type: RESET_CREATE_SEND,
});
